import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import type { LocalizedText } from '@cr/shared';
import { api } from '@/lib/api';
import { localized } from '@/lib/format';
import { EmptyState, ErrorState, Skeleton, SubHeader } from '@/components/ui';

interface Offer {
  version: number;
  content: LocalizedText;
}

/** Действующая редакция оферты целиком — на чекауте она показана свёрнутой. */
export default function OfferPage() {
  const { t } = useTranslation();

  const offer = useQuery({
    queryKey: ['offer'],
    queryFn: async () => (await api.get<Offer>('/catalog/offer')).data,
  });

  return (
    <div>
      <SubHeader title={t('checkout.offerRead')} />

      <div className="px-4 pb-10 sm:px-6">
        {offer.isLoading && (
          <div className="space-y-2">
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <Skeleton key={i} className="h-4 w-full" />
            ))}
          </div>
        )}

        {offer.isError && <ErrorState onRetry={() => void offer.refetch()} />}

        {offer.data && (
          <article className="rounded-card bg-surface p-4 shadow-soft">
            <p className="mb-3 text-xs text-muted">
              {t('profile.offerVersion', { version: offer.data.version })}
            </p>
            <div className="whitespace-pre-wrap text-sm leading-relaxed">
              {localized(offer.data.content)}
            </div>
          </article>
        )}

        {offer.isSuccess && !offer.data && <EmptyState title={t('profile.noOffer')} />}
      </div>
    </div>
  );
}
